<div class="exercises-filter">

  <div *ngIf="hidden('left')" class="filter-btn left" (click)="onLeftScroll()">
    <app-icon class="icon" icon="drag-scroll-arrow"></app-icon>
  </div>
  <div *ngIf="hidden('right')" class="filter-btn right" (click)="onRightScroll()">
    <app-icon class="icon" icon="drag-scroll-arrow"></app-icon>
  </div>

  <div #filter class="scrollbar-hidden">
    <div class="scroll">
      <ul class="filter-list">
        <li class="filter-item normal"
            [class.selected]="selectedFilter === '0'"
            (click)="onSelectFilter('0')">
          {{ 'content-type-title.all' | customLocale }}
        </li>
        <li *ngFor="let filter of filterList; let i = index"
            class="filter-item normal"
            [class.selected]="filter === selectedFilter"
            (click)="onSelectFilter(filter)">
          {{ contentTypeTitle(filter) | customLocale }}
        </li>
      </ul>
    </div>
  </div>
</div>
